import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Block, BlockHead, BlockTitle, Col, Icon, Row, RSelect } from '../../Component';
import { TENANT_CREATE_PROMOTION_DRAW_DATA_API, TENANT_RETRIEVE_CREATE_PROMOTION_DRAW_DATA_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, CREATE_PROMOTION_DRAW_ERROR_MSG, CREATE_PROMOTION_DRAW_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { fail_retrieve_create_promotion_draw_data, loading_retrieve_create_promotion_draw_data, reset_retrieve_create_promotion_draw_data, success_retrieve_create_promotion_draw_data } from '../../../reducers/auth_tenant/retrieve_create_promotion_draw_data_Slice';
import { getSelectedOption, messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import TextInput from '../../../pages/components/inputs/TextInput';
import { fail_create_promotion_draw, loading_create_promotion_draw, reset_create_promotion_draw, success_create_promotion_draw } from '../../../reducers/auth_tenant/create_promotion_draw_Slice';

const initialState = { draw_type: "", promotion_id: "", rules: { max_winners: "", allow_repeat_winners: false }, draw_at: "", participant_date_end: "", participant_date_start: "" };

const CreatePromotionDrawModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [sent_data, setSentData] = useState(data);
  const [submit_loading, setSubmitLoading] = useState(false);
  const [submit_error, setSubmitError] = useState("");
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    setError("");
    setSubmitError("");
    setSentData(data);
    setOpen(isOpen);
    setFormData(initialState);
    if (isOpen)
    {
      retrieve_data();
    }
  }, [isOpen, data]);

  const retrieve_data = () => {
    setError("");
    setSubmitError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_create_promotion_draw_data, success_retrieve_create_promotion_draw_data, fail_retrieve_create_promotion_draw_data, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_CREATE_PROMOTION_DRAW_DATA_API}`));
  };
  // Listener
  const retrieve_create_promotion_draw_data_listener = useSelector((state) => state.retrieve_create_promotion_draw_data.retrieve_create_promotion_draw_data);

  useEffect(() => {
    if (retrieve_create_promotion_draw_data_listener.status !== app_consts.IDLE)
    {
      if (retrieve_create_promotion_draw_data_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_create_promotion_draw_data_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_create_promotion_draw_data_listener.message, app_consts.FAIL);
          setError(retrieve_create_promotion_draw_data_listener.message);
        } else if (retrieve_create_promotion_draw_data_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_create_promotion_draw_data_listener.data);
        }
        dispatch(reset_retrieve_create_promotion_draw_data());
      }
    }
  }, [retrieve_create_promotion_draw_data_listener]);

  const repeatOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const handleCreatePromotionDraw = () => {
    setSubmitError("");
    // Dispatch
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes > 0 ? "-" : "+";
    const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

    const req_data = { ...formData, participant_date_start: `${formData?.participant_date_start}${formattedOffset}`, participant_date_end: `${formData?.participant_date_end}${formattedOffset}`, draw_at: `${formData?.draw_at}${formattedOffset}` };
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_create_promotion_draw, success_create_promotion_draw, fail_create_promotion_draw, CREATE_PROMOTION_DRAW_ERROR_MSG, CREATE_PROMOTION_DRAW_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_CREATE_PROMOTION_DRAW_DATA_API}`, { ...req_data, promotion_id: sent_data?.promotion?.id }));
  };
  // Listener
  const create_promotion_draw_listener = useSelector((state) => state.create_promotion_draw.create_promotion_draw);

  useEffect(() => {
    if (create_promotion_draw_listener.status !== app_consts.IDLE)
    {
      if (create_promotion_draw_listener.status === app_consts.LOADING)
      {
        setSubmitLoading(true);
        setSubmitError("");
      } else
      {
        setSubmitLoading(false);
        if (create_promotion_draw_listener.status === app_consts.FAIL)
        {
          messageToast(create_promotion_draw_listener.message, app_consts.FAIL);
          setSubmitError(create_promotion_draw_listener.message);
        } else if (create_promotion_draw_listener.status === app_consts.SUCCESS)
        {
          messageToast(CREATE_PROMOTION_DRAW_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
        }
        dispatch(reset_create_promotion_draw());
      }
    }
  }, [create_promotion_draw_listener]);


  return (
    <>
      <Modal isOpen={open} toggle={submit_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
        <ModalHeader toggle={submit_loading || loading ? "" : closeModal}>Create Promotion Draw</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Data...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <Col size={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="draw_type">
                              Draw Type<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">
                              <RSelect
                                options={page_data?.draw_types}
                                className="w-100"
                                placeholder="Search"
                                id="draw_type"
                                onChange={(e) => {
                                  setFormData({ ...formData, draw_type: e.value });
                                }}
                                value={getSelectedOption(formData?.draw_type, page_data?.draw_types)}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="draw_at">
                              Draw Date<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">

                              <input
                                type="datetime-local"
                                name="draw_at"
                                value={formData?.draw_at}
                                className="form-control"
                                min={new Date().toISOString().slice(0, 16)}
                                onChange={(e) => setFormData({ ...formData, draw_at: e.target.value })}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="participant_date_start">
                              Participant Date Start<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">

                              <input
                                type="datetime-local"
                                name="participant_date_start"
                                value={formData?.participant_date_start}
                                className="form-control"
                                min={sent_data?.promotion?.start_date}
                                onChange={(e) => setFormData({ ...formData, participant_date_start: e.target.value })}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="participant_date_end">
                              Participant Date End<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">

                              <input
                                type="datetime-local"
                                name="participant_date_end"
                                value={formData?.participant_date_end}
                                className="form-control"
                                max={sent_data?.promotion?.end_date}
                                onChange={(e) => setFormData({ ...formData, participant_date_end: e.target.value })}
                              />
                            </div>
                          </div>
                        </Col>
                        <Block>
                          <BlockHead>
                            <BlockTitle tag="h5">Rules</BlockTitle>
                          </BlockHead>
                        </Block>
                        <TextInput
                          label="Max Winners"
                          type="number"
                          id_val="max_winners"
                          value={formData?.rules?.max_winners}
                          colSize="6"
                          required
                          name="max_winners"
                          handleChange={(e) => setFormData({ ...formData, rules: { ...formData?.rules, max_winners: e.target.value } })}
                        />
                        <Col size={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="allow_repeat_winners">
                              Allow Repeat Winners<span className="text-danger pr-2"> *</span>
                            </label>
                            <div className="w-100">
                              <RSelect
                                options={repeatOptions}
                                className="w-100"
                                placeholder="Select"
                                id="allow_repeat_winners"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    rules: {
                                      ...formData.rules,
                                      allow_repeat_winners: e.value,
                                    },
                                  })
                                }
                                value={repeatOptions.find(
                                  (o) => o.value === formData?.rules?.allow_repeat_winners
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        {submit_error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {submit_error}{" "}
                            </Alert>
                          </div>
                        )}
                        <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                          <Button onClick={handleCreatePromotionDraw} disabled={submit_loading || !(formData?.draw_type && formData?.rules?.max_winners && formData?.draw_at && formData?.participant_date_end && formData?.participant_date_start)} color="primary">
                            {submit_loading ? <Spinner size="sm" color="light" /> : "Create Promotion Draw"}
                          </Button>
                        </Col>
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreatePromotionDrawModal;